import { flexCss } from "../../Flex"
import { styled, StyleProps } from "../../styles"
import { makeInputStyle } from "../../Input"

const SearchField = styled.div<{ disabled?: boolean }>((props: StyleProps & { disabled?: boolean }) => ({
  ...flexCss,
  ...makeInputStyle(props),
  width: `100%`,
  alignItems: `center`,
}))
export default SearchField
